import type { DocsArea } from '../console/help/docsBaseUrl';
import { WORKFLOWS_UI_ENABLED } from '../../config/productFeatures';

export type DocArticleMeta = {
  area: DocsArea;
  slug: string;
  /** Título en el índice */
  label: string;
  section: string;
  /** Texto para búsqueda (minúsculas recomendado) */
  keywords: string;
};

const DOC_CATALOG_ALL: DocArticleMeta[] = [
  { area: 'consola', slug: 'inicio', label: 'Inicio de la consola', section: 'Consola', keywords: 'dashboard métricas panel resumen' },
  { area: 'consola', slug: 'version', label: 'Versión y despliegue', section: 'Consola', keywords: 'versión release health despliegue iconos marca' },
  { area: 'consola', slug: 'agentes', label: 'Agentes virtuales', section: 'Consola', keywords: 'agente prompt modelo activar' },
  { area: 'consola', slug: 'plugins', label: 'Plugins del agente', section: 'Consola', keywords: 'extensiones calendario' },
  { area: 'consola', slug: 'plugin-config', label: 'Configuración de plugin', section: 'Consola', keywords: 'credenciales ajustes' },
  { area: 'consola', slug: 'canales', label: 'Canales e integraciones', section: 'Consola', keywords: 'whatsapp messenger telegram widget meta' },
  { area: 'consola', slug: 'conversaciones', label: 'Conversaciones', section: 'Consola', keywords: 'chat humano auto filtros lista' },
  { area: 'consola', slug: 'flujos', label: 'Flujos', section: 'Consola', keywords: 'workflow grafo activo' },
  { area: 'consola', slug: 'flujo-editor', label: 'Editor de flujo', section: 'Consola', keywords: 'nodos handoff publicar' },
  { area: 'consola', slug: 'aprendizajes', label: 'Aprendizajes', section: 'Consola', keywords: 'ejemplos atajos semánticos shortcuts' },
  { area: 'consola', slug: 'analisis-mensajes', label: 'Análisis de mensajes', section: 'Consola', keywords: 'estadísticas intenciones heurística' },
  { area: 'consola', slug: 'notificaciones', label: 'Notificaciones para operadores', section: 'Consola', keywords: 'alertas campana tipos' },
  { area: 'consola', slug: 'calendario-tipos-recurso', label: 'Calendario: tipos de recurso', section: 'Consola', keywords: 'agenda categoría duración' },
  { area: 'consola', slug: 'calendario-recursos', label: 'Calendario: recursos', section: 'Consola', keywords: 'agendable instancia' },
  { area: 'consola', slug: 'calendario-disponibilidad', label: 'Calendario: disponibilidad', section: 'Consola', keywords: 'horarios excepciones franjas' },
  { area: 'consola', slug: 'calendario-reservas', label: 'Calendario: reservas', section: 'Consola', keywords: 'turnos seña estado' },
  { area: 'consola', slug: 'calendario-vista', label: 'Vista de calendario', section: 'Consola', keywords: 'mes día consola' },
  { area: 'consola', slug: 's3-almacenamiento', label: 'Almacenamiento S3', section: 'Consola', keywords: 'bucket adjuntos archivos' },
  { area: 'consola', slug: 'demo-embed', label: 'Demo y embed', section: 'Consola', keywords: 'widget script sitio web' },
  { area: 'consola', slug: 'prueba-demo', label: 'Página de prueba', section: 'Consola', keywords: 'testchat interno' },
  { area: 'consola', slug: 'style-guide', label: 'Style guide', section: 'Consola', keywords: 'diseño componentes desarrollo' },
  { area: 'consola', slug: 'widget-demo', label: 'Demo pública (visitante)', section: 'Consola', keywords: 'token chat público' },
  { area: 'super-admin', slug: 'super-organizaciones', label: 'Empresas (super admin)', section: 'Super administración', keywords: 'organizaciones tenants alta' },
  { area: 'super-admin', slug: 'super-organizacion', label: 'Detalle de empresa', section: 'Super administración', keywords: 'usuarios consumo modelos' },
  { area: 'super-admin', slug: 'super-ia-plataforma', label: 'Modelos IA de plataforma', section: 'Super administración', keywords: 'claves api openai anthropic' },
];

const WORKFLOW_DOC_SLUGS = new Set(['flujos', 'flujo-editor']);

/** Índice navegable y buscable (alineado a `docs/` del repo). */
export const DOC_CATALOG: DocArticleMeta[] = WORKFLOWS_UI_ENABLED
  ? DOC_CATALOG_ALL
  : DOC_CATALOG_ALL.filter((d) => !WORKFLOW_DOC_SLUGS.has(d.slug));

export function catalogEntry(area: string, slug: string): DocArticleMeta | undefined {
  return DOC_CATALOG.find((d) => d.area === area && d.slug === slug);
}

export function filterCatalog(query: string): DocArticleMeta[] {
  const q = query.trim().toLowerCase();
  if (!q) return DOC_CATALOG;
  return DOC_CATALOG.filter(
    (d) =>
      d.label.toLowerCase().includes(q) ||
      d.slug.includes(q) ||
      d.keywords.includes(q) ||
      d.section.toLowerCase().includes(q)
  );
}
